import { useSyncExternalStore } from "react"

let isOpen = false
const listeners = new Set<() => void>()

export function setPromotionBannerOpen(open: boolean) {
  if (open === isOpen) return
  isOpen = open
  listeners.forEach(listener => listener())
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = () => isOpen
const getServerSnapshot = () => false

/** True while a bottom-docked PromotionBanner is open: the full-width banner, or the Promo Card on mobile. */
export function usePromotionBannerOpen() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
